define('models/distributor_personal',['require','backbone','models/phone_number','models/distributor','models/distributor_role'],function(require){

    var Backbone = require('backbone');

    var PhoneNumberModel = require('models/phone_number');
    var DistributorModel = require('models/distributor');
    var RoleModel = require('models/distributor_role');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'distributor-managers/' + this.id + '/' ) :
                ( App.Config.apiBase + 'distributor-managers/' );
        },

        defaults: function () {
            return {
                id:null,
                first_name: '',
                last_name: '',
                email: '',
                phone_number: new PhoneNumberModel().attributes,
                phone_country: 0,
                phone_value: '',
                role:0,
                role_object: new RoleModel().attributes,
            };
        }
    });
});
